
import { Grid } from '@mui/material';

import BenefitsBottomsheet from 'src/components/benefits-bottomsheet/benefits-bottomsheet';

import useDefaultLayout from './default-layout.hook';
import BottomNavigationComponent from './components/bottom-navigation/bottom-navigation';

type Props = {
  children: React.ReactNode;
};

export default function DefaultLayout({ children }: Props) {
  const {
    pathname,
    bottomNavHeight,
    bottomNavRef,
    sliderOpen,
    theme,
    isBenefitsBottomsheetOpen,
    showTooltip,
    invoiceRef,
    setIsBenefitsBottomsheetOpen,
    onClickBottomNavigation,
  } = useDefaultLayout();

  const pathsToVerify = ['test', 'auth', 'onboarding', 'memoryGame', 'myInterests', '404', '403', '500'];
  return (
    <Grid container justifyContent="center" sx={{ height: '100%', position: 'relative' }}>
      <Grid
        item
        xs={12}
        md={4}
        sx={{
          pb: `${!pathsToVerify.find((path) => pathname.includes(path)) ? bottomNavHeight : 0}px`,
          overflowY: 'auto',
        }}
      >
        {children}
      </Grid>

      {!pathsToVerify.find((path) => pathname.includes(path)) && (
        <BottomNavigationComponent
          invoiceRef={invoiceRef}
          showTooltip={showTooltip}
          pathname={pathname}
          sliderOpen={sliderOpen}
          onClickBottomNavigation={onClickBottomNavigation}
          bottomNavRef={bottomNavRef}
          theme={theme}
        />
      )}

      <BenefitsBottomsheet
        isOpen={isBenefitsBottomsheetOpen}
        onClose={() => setIsBenefitsBottomsheetOpen(false)}
      />
    </Grid >
  );
}
